export class CrfDetailsModel {
    "studyId":Number;
    "visitId":Number;
    "patientId":Number;
    "userId":Number;
}